<template>
  <!-- 平台产品详情 -->
  <div class="wrapper main-container">
    <loading :isShow="listLoading" />
    <Tabs v-model="selTab" :animated="false" v-if="!listLoading" @on-click="tabClick">
      <TabPane label="基本信息" name="1">
        <Form :model="productForm" ref="productFormRef" class="page-form" :label-width="140">
          <FormItem label="产品Code" prop="productCode">
            <Input disabled type="text" v-model="productForm.productCode" placeholder="请输入" />
          </FormItem>
          <FormItem label="产品名称" prop="productName">
            <span>{{ productForm.productName }}</span>
          </FormItem>
          <FormItem label="保险公司" prop="companyCode">
            <Select disabled v-model="productForm.companyCode" placeholder="请选择保险公司" filterable clearable>
              <Option :value="company.code" v-for="(company, index) in companyList" :key="index">{{ company.name }} </Option>
            </Select>
          </FormItem>
          <FormItem label="主附险类型" prop="productMainType">
            <span>主险</span>
          </FormItem>
          <FormItem label="产品类型标记" prop="productCategory">
            <span v-if="productForm.productCategory == 3">个险</span>
            <span v-else-if="productForm.productCategory == 1">团险</span>
            <span v-else-if="productForm.productCategory == 2">财产险</span>
          </FormItem>

          <FormItem label="险种分类" prop="themeIds">
            <selectTree
              :data="productThemeJoinVOS"
              :disabled="true"
              :multiple="true"
              :size="null"
              placeholder="请选择"
              :single="true"
              :showParentNode="true"
              :selectAllChildren="false"
              v-model="productForm.themeIds"
            >
            </selectTree>
          </FormItem>
          <FormItem label="监管分类" prop="regulatoryThemeId">
            <selectTree
              :data="productCategoryList"
              :disabled="true"
              :multiple="true"
              :size="null"
              placeholder="请选择"
              :single="true"
              :showParentNode="true"
              :selectAllChildren="false"
              v-model="productForm.regulatoryThemeId"
            >
            </selectTree>
          </FormItem>
          <FormItem label="长短险标志" prop="productType">
            <span v-if="productForm.productType == 1">长险</span>
            <span v-else-if="productForm.productType == 2">短险</span>
          </FormItem>
          <FormItem label="是否含身故" prop="includingDeath">
            <span v-if="productForm.includingDeath == 1">含身故</span>
            <span v-else-if="productForm.includingDeath == 0">不含身故</span>
          </FormItem>
          <FormItem v-if="!hideSupplier"  label="供应商类型" prop="supplierType">
            <span v-if="productForm.supplierType == 1">保司</span>
            <span v-else-if="productForm.supplierType == 2">通道</span>
          </FormItem>
          <FormItem v-if="!hideSupplier" label="供应商" prop="supplierId">
            <Select disabled v-model="productForm.supplierId" placeholder="请选择供应商" clearable filterable>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem v-if="productForm.id" label="是否有代理协议" prop="hasCovenant">
            <span v-if="productForm.hasCovenant == 1">是</span>
            <span v-else>否</span>
          </FormItem>
          <FormItem label="基础销量" prop="baseSalesNum">
            <span>{{ productForm.baseSalesNum }}</span>
          </FormItem>
          <FormItem class="flex" label="最低保费" prop="insureCost">
            <span>{{ productForm.insureCost }}</span>
            <span class="m-4">元起</span>
          </FormItem>
          <FormItem label="生效天数" prop="effectiveDay">
            <span>{{ productForm.effectiveDay }}</span>
          </FormItem>
          <FormItem label="是否需要回执" prop="isReceipt">
            <span v-if="productForm.isReceipt == 1">是</span>
            <span v-else-if="productForm.isReceipt == 0">否</span>
          </FormItem>
          <FormItem label="是否需要回访" prop="returnVisit">
            <span v-if="productForm.returnVisit == 1">是</span>
            <span v-else-if="productForm.returnVisit == 0">否</span>
          </FormItem>
          <FormItem class="flex" label="犹豫期" prop="hesitateTime">
            <span v-if="productForm.hesitateType == 1">回执当日起</span>
            <span v-else-if="productForm.hesitateType == 2">回执次日起</span>
            <span v-else-if="productForm.hesitateType == 3">生效日期起</span>
            <span style="margin-left: 4px;">{{ productForm.hesitateTime }}</span>
            <span>个自然日</span>
          </FormItem>
          <FormItem label="期数" prop="commissionNum">
            <span>{{ productForm.commissionNum }}</span>
          </FormItem>
          <FormItem label="是否税优险">
            <span>{{ productForm.shuiYouXian == 1 ? '是' : '否' }}</span>
          </FormItem>
          <Divider />
          <div class="title">档次/计划</div>
          <gradeAdditionsTable :productForm="productForm" :gradeAdditions="gradeAdditions" :look="true"/>

          <Divider />
          <div class="title">双主险/附加险</div>
          <Table :columns="columns1" :data="additionals"> </Table>
          <Divider />
          <div class="title">销售信息</div>
          <FormItem label="业务类别" prop="sellType">
            <Select disabled v-model="productForm.sellType" multiple placeholder="请选择业务类别">
              <Option value="1">网销产品</Option>
              <Option value="3">经代产品</Option>
            </Select>
          </FormItem>
          <FormItem label="投保方式" prop="insureType">
            <Select disabled v-model="productForm.insureType" multiple placeholder="请选择投保方式">
              <Option value="1">自投</Option>
              <Option value="2">代投</Option>
              <Option value="3" v-if="productForm.sellType && productForm.sellType.includes('3')">纸质</Option>
              <Option value="4">预约</Option>
              <Option value="5">收集</Option>
              <Option value="6">定投</Option>
              <Option v-if="$units.isWTS()" value="7">外链</Option>
            </Select>
          </FormItem>

          <FormItem label="区域" prop="productInsureAreas">
            <Tooltip theme="light" transfer max-width="500">
              <template #content>
                {{ productForm.productInsureAreas | area }}
              </template>
              <div class="area-wrap">
                {{ productForm.productInsureAreas | area }}
              </div></Tooltip
            >
          </FormItem>
          <Divider />
          <div class="title">内容管理</div>
          <FormItem class="upload-wrap full" prop="mobileCover">
            <template #label>
              <span>列表封面图</span>
              <Poptip trigger="hover" placement="right" transfer>
                <template #content>
                  <img class="example-img m" src="@static/images/product/ex02.png" />
                </template>
                <Icon type="ios-help-circle-outline" />
              </Poptip>
            </template>
            <upLoad :arr="productForm.mobileCover" :edit="false"></upLoad>
          </FormItem>
          <FormItem prop="titleLabel" class="full">
            <template #label>
              <span>PC/APP列表标签</span>
              <Poptip trigger="hover" transfer>
                <template #content>
                  <img class="example-img" src="@static/images/product/ex05.png" />
                  <br />
                  <img class="example-img" src="@static/images/product/ex06.png" />
                  <br />
                  <img class="example-img" src="@static/images/product/ex07.png" />
                </template>
                <Icon type="ios-help-circle-outline" />
              </Poptip>
            </template>
            <div v-if="productForm.titleLabel">
              <span class="tag" v-for="(i, index) in productForm.titleLabel" :key="index">{{ i }}</span>
            </div>
          </FormItem>
          <FormItem prop="feature" class="full">
            <template #label>
              <span>列表页产品简介</span>
              <Poptip trigger="hover" transfer>
                <template #content>
                  <img class="example-img" src="@static/images/product/ex08.png" />
                </template>
                <Icon type="ios-help-circle-outline" />
              </Poptip>
            </template>
            <span>{{ productForm.feature }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <Button @click="back()" ghost type="primary" slot="extra" style="margin-right: 10px; min-width: 88px">返回</Button>
      <TabPane label="内容管理" name="3">
        <div class="tab-wrap">
          <span :class="{ 'active': selSecTab == 1 }" @click="changeTab2(1)">文档资料</span>
          <span :class="{ 'active': selSecTab == 2 }" @click="changeTab2(2)">产品海报</span>
          <span :class="{ 'active': selSecTab == 4 }" @click="changeTab2(4)">投保流程</span>
        </div>
        <productManageRecourse v-show="selSecTab == 1" :edit="false" :productForm="productForm"> </productManageRecourse>
        <newProductManagePoster v-show="selSecTab == 2" :edit="false" :productForm="productForm"></newProductManagePoster>
        <!-- 投保流程 -->
        <product-process ref="productProcess" v-show="selSecTab == 4"></product-process>
      </TabPane>
      <TabPane v-if="productForm.id && $route.name != 'productManager.productAdd'" label="代理协议" name="4" key="4">
        <agreementList ref="agreementList" :productForm="productForm"></agreementList>
      </TabPane>
      <TabPane v-if="productForm.id && productForm.productCategory == '3'" label="回执回访指引" name="6" key="6">
        <Form :model="productForm" ref="productFormRef1" class="page-form" :rules="productFormRules" :label-width="140">
          <FormItem label="回执要求" prop="receiptStatus" :rules="$units.formRule.required('请选择')" class="full">
            <RadioGroup v-model="productForm.receiptStatus">
              <Radio label="0" disabled>需要回执</Radio>
              <Radio label="-1" disabled>无需回执</Radio>
              <Radio label="1" disabled>回执成功</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="回执操作流程" prop="receiptDesc" class="two" v-if="productForm.receiptStatus == '0'">
            <Input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 16 }"
              v-model="productForm.receiptDesc"
              placeholder="请输入"
              :disabled="productForm.sourceType != '2'"
            />
          </FormItem>
          <FormItem label="回访要求" prop="revisitStatus" :rules="$units.formRule.required('请选择')" class="full">
            <RadioGroup v-model="productForm.revisitStatus">
              <Radio label="0" disabled>需要回访</Radio>
              <Radio label="-1" disabled>无需回访</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="回访操作流程" prop="revisitDesc" class="two" v-if="productForm.revisitStatus == '0'">
            <Input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 16 }"
              v-model="productForm.revisitDesc"
              placeholder="请输入"
              :disabled="productForm.sourceType != '2'"
            />
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="上游结算规则" name="7">
        <settlement-desc ref="settlementDesc1" type="upstream"></settlement-desc>
      </TabPane>
      <TabPane label="对下结算规则" name="8">
        <settlement-desc ref="settlementDesc2" type="downstream"></settlement-desc>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import upLoad from './components/upload';
import { common } from '@/api/mixins';
import baseInfo from './components/baseInfo';
import agreementList from './components/agreementList';
import newProductManagePoster from './components/newProductManagePoster';
import gradeAdditionsTable from './components/gradeAdditionsTable';
import selectTree from '@/components/commons/selectTree';
import productManageRecourse from './components/productManageRecourse';
import productProcess from './components/productProcess';
import settlementDesc from './components/settlementDesc';
export default {
  components: {
    upLoad,
    baseInfo,
    productProcess,
    settlementDesc,
    selectTree,
    agreementList,
    newProductManagePoster,
    gradeAdditionsTable,
    productManageRecourse
  },
  mixins: [common],
  filters: {
    area(val) {
      if (!val) return val;
      let data = val
        .map(item => {
          return item.cityName + '/' + item.provinceName;
        })
        .join();
      return data;
    }
  },
  data() {
    return {
      supplierList: [],
      productThemeJoinVOS: [],
      companyList: [],
      productFormRules: {},
      productForm: {
        themeIds: [],
        publishStatus: '1'
      },
      columns1: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '险种code',
          key: 'addCode',
          align: 'center',
          minWidth: 130
        },
        {
          title: '主附险类型',
          key: 'type',
          align: 'center',
          minWidth: 300,
          render(h, params) {
            return <span>{params.row.type == 1 ? '附加险' : '主险'}</span>;
          }
        },
        {
          title: '产品名称',
          key: 'addName',
          align: 'center',
          minWidth: 300
        }
      ],
      listLoading: false,
      hideSupplier:false,
      id: '',
      pageNo: 1,
      pageSize: 10,
      productCategoryList: [],
      selTab: '1',
      selSecTab: '1',
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center'
        },
        {
          title: '附加险信息',
          key: 'addName',
          align: 'center'
        },
        {
          title: '附加险code',
          key: 'addCode',
          align: 'center'
        }
      ],
      gradeAdditions: [], //档次/计划
      additionals: [], //附加险
    };
  },
  created() {
    this.selTab = this.$route.query.tab || '1';
    this.id = this.$route.query.id; //产品id
    this.hideSupplier = this.$route.query.hideSupplier; //是否隐藏供应商
    this.getDetail();
    this.queryProductClassification();
    this.queryInsuranceCompany();
  },
  methods: {
    tabClick() {
      // 上游结算规则
      if (this.selTab == 7) {
        this.$refs.settlementDesc1.init(this.productForm);
      } else if (this.selTab == 8) {
        this.$refs.settlementDesc2.init(this.productForm);
      }
    },
    changeTab2(selSecTab) {
      this.selSecTab = selSecTab;
      // 投保流程
      if (this.selTab == 3 && this.selSecTab == 4) {
        this.$refs.productProcess.init(this.productForm);
      }
    },
    //获取保司
    queryInsuranceCompany() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: 1
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    async getDetail() {
      this.listLoading = true;
      const res = await this.$http({
        url: '/buz/productBase/read/detail/v2',
        type: 'GET',
        data: { id: this.id }
      });
      const productForm = res.data.productBase;
      this.additionals = res.data.additionals || []; //附加险
      this.gradeAdditions = res.data.gradeAdditions || []; //档次/计划
      if (productForm.goodness) {
        try {
          if (productForm.goodness.indexOf('[') != -1) {
            productForm.goodness = JSON.parse(productForm.goodness);
          } else {
            productForm.goodness = productForm.goodness.replace(/<br>/g, '\n').split(/[\n]/);
          }
        } catch (error) {
          productForm.goodness = productForm.goodness.replace(/<br>/g, '\n').split(/[\n]/);
        }
      } else {
        productForm.goodness = [];
      }
      if (productForm.titleLabel) {
        try {
          if (productForm.titleLabel.indexOf('[') != -1) {
            productForm.titleLabel = JSON.parse(productForm.titleLabel);
          } else {
            productForm.titleLabel = productForm.titleLabel.split(',');
          }
        } catch (error) {
          productForm.titleLabel = productForm.titleLabel.split(',');
        }
      } else {
        productForm.titleLabel = [];
      }
      // 处理历史数据，转为为数组
      if (!isNaN(productForm.sellType)) {
        productForm.sellType = `[${productForm.sellType}]`;
      }
      if (!isNaN(productForm.insureType)) {
        productForm.insureType = `[${productForm.insureType}]`;
      }
      try {
        // 未配置时默认类型1 自投 网销
        productForm.sellType = productForm.sellType && productForm.sellType != '[]' ? JSON.parse(productForm.sellType) : [];
        productForm.insureType = productForm.insureType && productForm.insureType != '[]' ? JSON.parse(productForm.insureType) : [];
      } catch (error) {}
      productForm.settlementDescription = productForm.settlementDescription
        .split(/[\n]/)
        .map(item => {
          return '<p>' + item + '</p>';
        })
        .join('');
      productForm.productInsureAreas = res.data.productInsureAreas;
      productForm.productMainType = '1';
      productForm.regulatoryThemeId = productForm.regulatoryThemeId ? productForm.regulatoryThemeId.split(',') : [];
      productForm.earliestRenewalDay = productForm.earliestRenewalDay && productForm.earliestRenewalDay.toString();
      productForm.latestRenewalDay = productForm.latestRenewalDay && productForm.latestRenewalDay.toString();
      if (productForm.supplierType) {
        this.selectSupplier(productForm.supplierType);
      }
      this.listLoading = false;
      productForm.themeIds = [];
      this.productForm = productForm;
      if (productForm.productThemeJoinVOS) {
        this.productThemeJoinVOS = this.dealTree1(productForm.productThemeJoinVOS);
      }
      this.initData();
    },
    initData() {
      this.$nextTick(() => {
        this.$refs.productProcess.init(this.productForm);
      });
    },
    selectSupplier(val) {
      console.log(val);
      if (!val) {
        this.supplierList = [];
        this.productForm.supplierId = '';
        return;
      }
      this.$http({
        url: val == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (val) {
          this.supplierList = res.data;
        } else {
          this.supplierList = [];
        }
      });
    },
    // 获取产品类别
    queryProductClassification() {
      this.$http({
        url: '/buz/productRegulatoryTheme/read/tree',
        type: 'GET'
      }).then(res => {
        this.productCategoryList = this.dealTree(res.data);
      });
    },
    dealTree1(arr) {
      return arr.map(item => {
        if (item.checked) this.productForm.themeIds.push(item.themeId);
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree1(item.child) : null
        };
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        disabled: item.children && item.children.length ? true : false,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    }
  }
};
</script>
<style lang="scss" scoped>
.example-img {
  max-width: 800px;
  max-height: 200px;
}

/deep/.ivu-icon-ios-help-circle-outline {
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 4px;
}

.tag {
  display: inline-block;
  line-height: 22px;
  margin: 2px 4px 2px 0;
  padding: 0 8px;
  border-radius: 3px;
  font-size: 12px;
  vertical-align: middle;
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff !important;
}

/deep/ .videoIMG {
  > div {
    width: 400px !important;
    height: 400px !important;
    height: auto;
    margin: 0 !important;
  }
}

/deep/.ivu-tabs {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);

  .ivu-tabs-bar {
    flex: 0 0 40px;
  }

  .ivu-tabs-content {
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

.tab-wrap {
  // border-bottom: 1px solid #ececec;
  span {
    cursor: pointer;
    padding: 6px 0 6px;
    margin-right: 44px;
    font-size: 13px;
    color: #515c6f;
    display: inline-block;
  }

  .active {
    position: relative;
    color: #236dff;
    // border-bottom: 2px solid #236dff;
  }
}

.area-wrap {
  cursor: pointer;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.wrapper {
  flex-direction: column;

  .form-body {
    margin-top: 20px;

    .productForm {
      .ivu-form-item {
        width: calc((100% - 30px) / 3);
      }
    }
  }

  /deep/.flex .ivu-form-item-content {
    display: flex;
    white-space: nowrap;
  }

  .c-red {
    color: #ed4014;
    font-size: 13px;
  }

  .title {
    font-weight: 800;
    margin-bottom: 20px;
  }

  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }

    .ivu-tabs-ink-bar {
      display: none;
    }

    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }

    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}
</style>
